// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3Xf5C9YqvX0L5EJThudT4n {\n    line-height: 1.25;\n}\n\n._3Xf5C9YqvX0L5EJThudT4n img {\n    width: 100%;\n}\n\n._3Xf5C9YqvX0L5EJThudT4n table {\n    width: 100%;\n    line-height: 1.5;\n    margin-bottom: 1em;\n}\n\n._3Xf5C9YqvX0L5EJThudT4n table td,\n._3Xf5C9YqvX0L5EJThudT4n table th {\n    border-bottom: 1px solid #ccc;\n    padding: 4px 0;\n}\n\n._3Xf5C9YqvX0L5EJThudT4n ul,\n._3Xf5C9YqvX0L5EJThudT4n ol {\n    padding-left: 1.3em;\n}\n\n._3Xf5C9YqvX0L5EJThudT4n li + li {\n    margin-top: 8px;\n}\n", ""]);
// Exports
exports.locals = {
	"markdown": "_3Xf5C9YqvX0L5EJThudT4n"
};
module.exports = exports;
